<button type="button" (click)="onClick()" [disabled]="isDisabled()" class="w-full h-10 flex items-center justify-center bg-primary-800
  hover:bg-primary-900 text-white font-semibold text-xs rounded
  transition-colors
  disabled:opacity-40 disabled:cursor-not-allowed
  cursor-pointer">
  @if(isLoading()) {
  <span class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
  } @else {
  <span>{{ text() }}</span>
  }
</button>